import React from 'react';
import { Button, Card, CardBody, Col, Modal } from 'reactstrap';
import CloseButton from "@/shared/components/CloseButton";

const InvoicingCycleRunConfirm = ({ action, period, isRunning, isOpen, toggle }) => {

  return (
    <Modal className={`modal-small modal-md p-0`} isOpen={isOpen} toggle={toggle}>
      <CloseButton onClick={toggle} />
      <Card className='w-100'>
        <CardBody className='text-center'>
          <div className='w100'>
            <Col md="12" lg="12" xl="12">
              <div className="card__title">
                <h5 className="colorgrey">Run both invoicing cycles for {period}?</h5>
                <p className='colorgrey'>
                  This creates real invoices for every selected program, exactly as the monthly
                  cron does. Programs already invoiced for this period are skipped. A full run takes
                  a minute or more - leave this open until it reports back.
                </p>
              </div>
            </Col>
          </div>
          <div className='w100'>
            <Col md="12" lg="12" xl="12">
              <div className='mt-3'>
                <Button color='primary' type='submit' disabled={isRunning} onClick={action}>
                  {isRunning ? 'Running...' : 'Yes'}
                </Button>&nbsp;&nbsp;&nbsp;
                <Button color='danger' type='submit' disabled={isRunning} onClick={toggle}>No</Button>
              </div>
            </Col>
          </div>
        </CardBody>
      </Card>
    </Modal>
  )
}

export default InvoicingCycleRunConfirm;
